<template>
    <div class="pl-navigator-main-page">
        <component class="pl-navigator-main-page-target"
                   ref="target"
                   v-if="page.init"

                   :path="page.path"
                   :is="page.component"
                   :src="page.path"

                   :pageTabData="tab"
                   :pageSecurity="pageSecurity"
                   :pageParam="p_pageParam"/>
		<link-loading-shadow :value="pageLoading">
			<div class="page-loading-message" v-if="pageLoadingMsg">{{pageLoadingMsg}}</div>
		</link-loading-shadow>
    </div>
</template>

<script>
  	import {LovService} from 'src/utils/lov';
    export default {
        name: "pl-navigator-main-page",
        props: {
            id: {},
            page: {},
            tab: {},
        },
	  	provide() {
          console.log(this.module)
          return {
            $linkModuleHttp: this.$linkModuleHttp,
			$linkModule: this.module,
            $linkModuleLov: this.$linkModuleLov
		  }
		},
        data() {

            return {
                parent: null,
                listenEvents: [],
                queryParam: null,
                pageLoading: false,
                pageLoadingMsg: '',
            }
        },
        created() {
            this.parent = this.$lv.$dom.findComponentUpward(this, 'pl-navigator-main-tab')
            const {param} = this.$lv.$utils.decodeUrl(this.page.path)
            this.queryParam = param
        },
		watch: {
			pageLoading(v){
				if(v) return;
				this.pageLoadingMsg = '';
			}
		},
        computed: {
            p_pageParam() {
                return Object.assign({}, this.queryParam, this.pageParam)
            },
		  module() {
            const reg = /\/(.+?)\//
            if(reg.test(this.page.path)) {
              return RegExp.$1.trim()
			}
            if (/^(\[).*(\])$/.test(this.page.path)) {
              // nocode模块
              return 'nocode'
            }
            return this.page.path
		  },
		  // 根据当前页面所属模块返回对应的http请求对象实例
          $linkModuleHttp() {
			const reg = /\/(.+?)\//
			if(reg.test(this.page.path)) {
			  const modules = RegExp.$1.trim()
			  if(modules === 'modules-qw' && this.$lv.Vue.prototype.$httpQw) {
				return this.$lv.Vue.prototype.$httpQw
			  }
			}
            if (/^(\[).*(\])$/.test(this.page.path)) {
              // nocode模块
              return this.$lv.Vue.prototype.$httpQw || this.$lv.Vue.prototype.$http
			}
			return this.$lv.Vue.prototype.$http
		  },
		  // 根据当前页面所属模块返回对应的值列表转换服务实例
		  $linkModuleLov() {
            const reg = /\/(.+?)\//
            if(reg.test(this.page.path)) {
              const modules = RegExp.$1.trim()
              if(modules === 'modules-qw') {
                if(!this.$lv.Vue.prototype.$lovQw) {
                  // 为企微模块另外创建一个值列表service实例，实现数据隔离
                  this.$lv.Vue.prototype.$lovQw = new LovService(this.$lv, '$httpQw')
				}
                return this.$lv.Vue.prototype.$lovQw
              }
            }
            if (/^(\[).*(\])$/.test(this.page.path) && this.$lv.Vue.prototype.$httpQw) {
              // nocode模块
              if(!this.$lv.Vue.prototype.$lovQw) {
                // 为企微模块另外创建一个值列表service实例，实现数据隔离
                this.$lv.Vue.prototype.$lovQw = new LovService(this.$lv, '$httpQw')
              }
              return this.$lv.Vue.prototype.$lovQw
			}
            return this.$lv.Vue.prototype.$lov
		  }
        },
        methods: {
            async refresh() {
                this.page.init = false
                await this.$lv.nextTick()
                this.page.init = true
            },
            onBack(data) {
                !!this.$refs.target && !!this.$refs.target.onBack && this.$refs.target.onBack(data)
            },
            /**
             * 监听事件
             * @author  韦胜健
             * @date    2019/3/19 18:50
             */
            on(event, callback) {
                this.listenEvents.push({event, callback})
                this.parent.on(event, callback)
            },

            /**
             * 只监听一次事件
             * @author  韦胜健
             * @date    2019/3/19 18:51
             */
            once(event, callback) {
                this.listenEvents.push({event, callback})
                this.parent.once(event, callback)
            },

            /**
             * 移除事件
             * @author  韦胜健
             * @date    2019/3/19 18:51
             */
            off(event, callback) {
                for (let i = 0; i < this.listenEvents.length; i++) {
                    const {event: e, callback: c} = this.listenEvents[i];
                    if (event !== e) continue
                    if (callback == null || callback === c) {
                        this.listenEvents.splice(i, 1)
                        this.parent.off(event, callback)
                        i--
                        return true
                    }
                }
                return false
            },

            /**
             * 派发事件
             * @author  韦胜健
             * @date    2019/3/19 18:51
             */
            emit(event, param, global) {
                this.parent.emit(event, param, global)
            },
        },
        beforeDestroy() {
            /*页面销毁*/
            if (!this.parent) return
            this.listenEvents.forEach(({event, callback, global}) => this.parent.off(event, callback, global))
        },
    }
</script>

<style lang="scss">
    .pl-navigator-main-page {
        & > .link-loading-shadow {
            background-color: rgba(white, 0.5);
        }
    }
	@include themeify {
		.page-loading-message{
			color: pl-var(color-primary);
			font-size: 14px;
		}
	}
</style>
